export default __webpack_public_path__ + "static/media/quotationCreateGif4.3985370c.gif";